import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Colors } from "../../styles/colors";

export const LMic = ({ scale = 1, ...props }: MicProps): JSX.Element => {
    const width = (scale * 30).toString();
    const height = (scale * 48).toString();

    return (
        <div className="microphone-indicator">
            <svg width={width} height={height} viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="g" x2="0" y1="100%" y2="0%">
                        <stop offset={props.volume} stopColor={props.color ?? Colors.primaryBlue}></stop>
                        <stop offset="0%" stopColor="white"></stop>
                    </linearGradient>
                </defs>
                <path
                    d="M14.9951 37.001V47.001"
                    stroke={props.color ?? Colors.primaryBlue}
                    strokeWidth="1.5484"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 1C12.8783 1 10.8435 1.84286 9.34316 3.34316C7.84286 4.84346 7 6.8783 7 9.00004V23.0001C7 25.1219 7.84286 27.1567 9.34316 28.657C10.8435 30.1573 12.8783 31.0002 15 31.0002C17.1218 31.0002 19.1566 30.1573 20.6569 28.657C22.1572 27.1567 23.0001 25.1219 23.0001 23.0001V9.00004C23.0001 6.8783 22.1572 4.84346 20.6569 3.34316C19.1566 1.84286 17.1218 1 15 1V1Z"
                    stroke={props.color ?? Colors.primaryBlue}
                    strokeWidth="1.5484"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="url(#g)"
                />
                <path
                    d="M29.0002 17.002V23.002C29.0002 26.715 27.5252 30.276 24.8996 32.9015C22.2741 35.5271 18.7131 37.0021 15.0001 37.0021C11.287 37.0021 7.72605 35.5271 5.10053 32.9015C2.475 30.276 1 26.715 1 23.002V17.002"
                    stroke={props.color ?? Colors.primaryBlue}
                    strokeWidth="1.5484"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <div
                className={`microphone-status is-flex is-flex-row is-align-items-center ${
                    props.showRec ? "" : "is-hidden-custom"
                }`}
            >
                <FontAwesomeIcon icon={solid("circle")} size="2xs" color={Colors.primaryRed} className="mr-2" />
                <div className="has-text-dark-blue has-text-weight-semibold">REC</div>
            </div>
        </div>
    );
};

interface MicProps {
    volume?: number;
    showRec?: boolean;
    scale?: number;
    color?: string;
}
